/*
 * @Desc: 
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-04-06 14:35:12
 */
/*
 * @Desc: 
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-03-03 09:52:23
 */
import { LOGIN, LOGOUT } from '.././mutation_types'

// localStorage 保存数据时间更久，不会因为关闭标签而丢失

const state = {
    user_id: localStorage.getItem("user_id") || 0,
    user_name: localStorage.getItem("user_name") || '未登录',
    token: localStorage.getItem("token") || '',
    admin_role: localStorage.getItem("admin_role") || 0,
}

const getters = {
    user_id: state => {
        return state.user_id
    },
    user_name: state => {
        return state.user_name
    },
    token: state => {
        return state.token
    },
    admin_role: state => {
        return state.admin_role
    }
}

const mutations = {
    [LOGIN] (state, data) {
        localStorage.setItem("user_id", data.id);  // 设置localStorage
        localStorage.setItem("user_name", data.name);
        localStorage.setItem("token", data.token);
        localStorage.setItem("admin_role", data.admin_role);
        state.user_id = data.id;
        state.user_name = data.name;
        state.token = data.token;
        state.admin_role = data.admin_role;
    },
    [LOGOUT] (state) {
        localStorage.removeItem("user_id");  //移除localStorage
        localStorage.removeItem("user_name");
        localStorage.removeItem("token");
        localStorage.removeItem("admin_role");
        state.user_id = 0
        state.user_name = '';
        state.token = '';
        state.admin_role = 0;
    }
}

export default {
    state,
    mutations,
    getters
}